import { render } from "./customerLevelList.vue?vue&type=template&id=2d7520b4&scoped=true"
import script from "./customerLevelList.vue?vue&type=script&lang=js"
export * from "./customerLevelList.vue?vue&type=script&lang=js"

import "./customerLevelList.vue?vue&type=style&index=0&id=2d7520b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7520b4"]])

export default __exports__